// export const API_URL = 'https://crm-metrology.ru/api';
// export const API_URL_CONTENT_MY = 'https://crm-metrology.ru/api/upload';
export const API_URL = 'https://vgoste.ru/api';
export const API_URL_CONTENT_MY = 'https://vgoste.ru/api/upload';
export const IS_DEBUG = true;
